module.exports = __webpack_public_path__ + "static/media/pdfCover.10dfd921.png";